import { variables } from '../../common/variables';
import { makeMarkerIcon } from './markerIcon';
import { cl } from '../../common/functions';
let map;
let markersCluster;
if (variables.shortcodeTypeValue) {
  if (document.getElementById("map")) {
    // leaflet map init
    map = L.map('map', {
      gestureHandling: true
    });
    const osmUrl = 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
    const osmAttrib = 'Map data © OpenStreetMap contributors';
    const osm = new L.TileLayer(osmUrl, { attribution: osmAttrib });
    map.addLayer(osm);

    // fullscreen
    map.addControl(new L.Control.Fullscreen());

    //Cluster de markers
    markersCluster = L.markerClusterGroup({
      disableClusteringAtZoom: 18,
      iconCreateFunction: cluster => {
        return makeMarkerIcon(null, null, variables.primaryColor, "cluster", cluster.getChildCount())
      }
    });

    if (variables.shortcodeTemplateValue === 'full') {
      const shortcodeSearchLanguageValue = !!variables.shortcodeSearchLanguageValue ? `${variables.shortcodeSearchLanguageValue}'` : '';
      const shortcodeSearchCountryValue = !!variables.shortcodeSearchCountryValue ? `${variables.shortcodeSearchCountryValue}` : '';
      if (variables.shortcodeSearchTypeValue !== 'custom') {
        //Search-control
        const searchControl = new GeoSearch.SearchControl({
          style: 'bar',
          showMarker: false,
          showPopup: false,
          searchLabel: 'Rechercher une ville...',
          notFoundMessage: 'Aucun résultat trouvé',
          zoomLevel: 11,
          animateZoom: true,
          autoClose: true,
          keepResult: true,
          maxSuggestions: 4,
          provider: new GeoSearch.OpenStreetMapProvider({
            params: {
              'accept-language': shortcodeSearchLanguageValue,
              countrycodes: shortcodeSearchCountryValue,
              addressdetails: 0
            }
          })
        });
        map.addControl(searchControl);
      }
    }
    // Ajoute l'instance de la map & des markers cluster dans le window
    window.gl.map_element = map;
    window.gl.marker_cluster_element = markersCluster;
  }
}
export { map, markersCluster };
